import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import type { LevumiSubject } from '../../../enums/CampusLevumiEnums.js';

@Entity()
export class CampusLevumiLevel extends MongoEntity {
  public static override _class = 'CampusLevumiLevel';
  public static override _collectionName = 'campus-levumi-level';

  public static override get allFields() {
    return selectionSet(() => this, 1);
  }

  @Field(() => String)
  public level!: string;

  @Field(() => String)
  public subject!: LevumiSubject;
}
